if (window.innerWidth >= 768 && 'IntersectionObserver' in window) {
  document.querySelectorAll('[data-cc-animate]:not([data-cc-animate-init])').forEach((el) => {
    el.setAttribute('data-cc-animate-init', '');

    if (el.dataset.ccAnimateDelay) {
      el.style.transitionDelay = el.dataset.ccAnimateDelay;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => el.classList.add('is-in'), 200);
          observer.unobserve(entry.target);
        }
      });
    });

    observer.observe(el);
  });
}
